import React from 'react'
import { Datagrid, List, TextField } from 'react-admin'

const PocList = () => (
  <List exporter={false}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="title" />
    </Datagrid>
  </List>
)

export default PocList
